import { Producer } from "@main/producers/models/Producer";

export interface IUser {
    id: number;
    name: string;
    surnames: string;
    email: string;
    role: string;
    roles: any[];
    password: string;
    password_confirmation: string;
    permissions: string[];
    extra_data: any;
    producer?: Producer
    created_at: string;
    updated_at: string;
    deleted_at: string;
}
export class User {
    public id: any;
    public name: string;
    public surnames: string;
    public email: string;
    public role: string;
    public roles: any[];
    public password: string;
    public password_confirmation: string;
    public permissions: string[];
    public extra_data: any;
    public producer?: Producer;
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;

    constructor() {
        this.id = null;
        this.name = '';
        this.surnames = '';
        this.email = '';
        this.role = '';
        this.roles = [];
        this.password = '';
        this.password_confirmation = '';
        this.permissions = [];
        this.extra_data = {};
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';        
    }
}